import * as React from 'react';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const propTypes = {};
const propKeysToRemove = Object.keys(propTypes);
/**
 * Description/sub-title field for a list item in the AnchorBar
 *
 * @subcomponent AnchorBar
 */ const AnchorBarListItemDescription = renderWithRef('AnchorBarListItem', propTypes, (props, ref)=>{
    const classNames = new Set([
        'swan-anchor-bar-list-item-description'
    ]);
    const { children } = props;
    return /*#__PURE__*/ React.createElement(RenderComp, {
        root: "span",
        forwardedRef: ref,
        propKeysToRemove: propKeysToRemove,
        classNames: classNames,
        props: props
    }, children);
});

export { AnchorBarListItemDescription };
